export type SubscriptionPermissionType = {
  [key: string]: string;
};
